module.exports = __webpack_public_path__ + "img/LAST_ACTIVITIES.68022bc0.svg";